export function Kpi({ n, label, color, dt }: { n: number; label: string; color: string; dt: boolean }) {
  return (
    <div class={dt ? 'kpi-card' : 'card'} style={{ textAlign: 'center' }}>
      <div style={{ fontSize: dt ? 28 : 24, fontWeight: 600, color: `var(${color})` }}>{n}</div>
      <div class="muted">{label}</div>
    </div>
  );
}
